(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glimpses-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.glimpses-section').forEach((section) => {
    section.querySelectorAll('[data-glimpses-sound-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const video = button.previousElementSibling?.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        button.setAttribute('aria-pressed', String(!video.muted));
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
